import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocMaintenanceRoute: InvariantJiraRoute = {
	name: 'eoc-maintenance',
	path: '/jira/ops/teams/:teamId/maintenance',
	exact: true,
};
